import { Spinner, Switch } from '@chakra-ui/react';
import { useTranslate } from '@tolgee/react';
import { toaster } from 'provider/src/module/chakra-ui/components/ui/toaster';
import { useParams, useSearchParams } from 'react-router-dom';
import { useSetPrintRuleAssignment } from '../../print-rule/logic/use-set-print-rule-assignment';
import convertStringToRuleService from '../../util/convert-string-to-rule-service';
import { useCheckPrintRuleAssignment } from '../logic/use-check-assignment';

export default function AssignmentSwitchButton(props: { menuPrintRuleId: string }) {
  const { data } = useCheckPrintRuleAssignment(props.menuPrintRuleId);

  const { t } = useTranslate();
  const menuId = useParams().menuId ?? '';

  const [searchParams] = useSearchParams();
  const service = convertStringToRuleService(searchParams.get('service') ?? '');

  const [update, { loading }] = useSetPrintRuleAssignment();

  const setAssignment = (checked: boolean) => {
    update({
      variables: {
        input: {
          menuId: menuId,
          menuPrintRuleId: props.menuPrintRuleId,
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          service: service!,
          checked,
        },
      },
    })
      .then(() => {
        toaster.create({
          description: t('print-rule.set-assignment', 'Set print rule assignment successful'),
          type: 'info',
        });
      })
      .catch(() => {
        toaster.create({
          description: t('print-rule.set-assignment.error', 'Set print rule assignment failed'),
          type: 'error',
        });
      });
  };

  return (
    <Switch.Root
      border={'solid 1px'}
      p={2}
      borderColor={'gray.300'}
      rounded={'md'}
      onCheckedChange={(e) => {
        setAssignment(e.checked);
      }}
      checked={data?.checkPrintRuleAssignment?.id ? true : false}
    >
      <Switch.HiddenInput />
      <Switch.Control />
      <Switch.Label>{t('assignment', 'Assigment')}</Switch.Label>
      {loading && <Spinner />}
    </Switch.Root>
  );
}
